import { Box, Typography, useColorScheme } from '@mui/material';
import { GlassColors } from '../../components/glassmorphism/GlassmorphismStyles';

const benefits = [
  {
    title: 'Zero Upfront Costs. Quoting is 100% Free',
    text: (
      <>
        Stop buying credits for dead leads. On <strong>Womapp</strong>, there
        are no subscriptions and quoting is <strong>completely free</strong>.
        Browse local jobs and send quotes risk-free. If you don't get hired, you{' '}
        <strong>don't lose a single penny.</strong>
      </>
    ),
    icon: (
      <svg
        width='140'
        height='140'
        viewBox='0 0 140 140'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_dddii_2039_438)'>
          <path
            d='M52.7406 12.4147C60.148 10.247 67.8304 9.53349 75.572 10.2956C83.3137 11.0576 90.7092 13.2538 97.5536 16.8236C104.649 20.5249 110.824 25.5394 115.905 31.7296C120.986 37.9198 124.701 44.9527 126.949 52.6339L126.947 52.6327C129.115 60.0401 129.829 67.7225 129.066 75.4641C128.306 83.2057 126.11 90.6013 122.54 97.4458C118.838 104.541 113.824 110.716 107.634 115.797C101.443 120.878 94.4105 124.594 86.7293 126.841C81.2384 128.448 75.5957 129.255 69.8914 129.255C67.9003 129.255 65.9009 129.157 63.898 128.96C56.1563 128.199 48.7607 126.003 41.9163 122.433C34.8206 118.732 28.6458 113.717 23.5649 107.527C11.092 92.3329 6.89408 71.9844 12.3352 53.095C12.6078 52.1516 13.5928 51.6075 14.5362 51.8789C15.4796 52.1515 16.0235 53.1364 15.7521 54.0798C10.6345 71.8445 14.5823 90.9817 26.3121 105.271C31.0872 111.088 36.8899 115.802 43.559 119.28C49.9981 122.639 56.9575 124.705 64.244 125.422C71.5305 126.139 78.7589 125.468 85.729 123.43C92.9479 121.318 99.5578 117.825 105.376 113.05C111.194 108.275 115.907 102.472 119.386 95.8031C122.745 89.364 124.811 82.4045 125.528 75.118C126.245 67.8315 125.574 60.6031 123.535 53.6331C121.423 46.4141 117.93 39.8043 113.155 33.9862C108.38 28.1681 102.578 23.4546 95.9086 19.9761C89.4707 16.6173 82.5101 14.5515 75.2235 13.8344C67.937 13.1174 60.7086 13.7883 53.7385 15.8268C46.5195 17.9388 39.9098 21.4316 34.0917 26.2067C33.3332 26.8289 32.2132 26.7187 31.5898 25.9601C30.9675 25.2016 31.0778 24.0816 31.8363 23.4582C38.0265 18.3773 45.0594 14.6618 52.7406 12.4147Z'
            fill='#005CAD'
          />
          <path
            d='M64.0804 18.7412C70.9011 17.9554 77.6994 18.5456 84.2866 20.4964C90.8739 22.4472 96.8981 25.6543 102.19 30.0276C107.293 34.2457 111.496 39.3574 114.681 45.2217C117.865 51.086 119.865 57.3948 120.623 63.9725C121.409 70.7921 120.819 77.5915 118.868 84.1788C114.079 100.347 101.648 113.121 85.6152 118.346C84.6813 118.65 83.6786 118.141 83.374 117.207C83.0695 116.274 83.5791 115.271 84.513 114.966C99.4333 110.102 111.002 98.2161 115.458 83.1691C117.273 77.0428 117.821 70.721 117.09 64.3791C116.384 58.2553 114.522 52.3803 111.555 46.9178C108.589 41.4553 104.675 36.6943 99.924 32.7678C95.0031 28.7014 89.4018 25.7196 83.2756 23.9051C77.1494 22.0905 70.8276 21.5417 64.4857 22.273C58.3619 22.9794 52.4869 24.8413 47.0244 27.8078C41.5619 30.7743 36.801 34.6878 32.8745 39.4392C28.8081 44.3601 25.8261 49.9614 24.0116 56.0876C22.1971 62.2138 21.6484 68.5356 22.3797 74.8775C23.0861 81.0013 24.948 86.8762 27.9145 92.3387C30.881 97.8013 34.7945 102.562 39.5459 106.489C44.4668 110.555 50.0679 113.537 56.1941 115.352C57.1352 115.63 57.6721 116.62 57.3936 117.561C57.1648 118.333 56.4561 118.834 55.6893 118.834C55.5222 118.834 55.3515 118.81 55.1833 118.76C48.596 116.809 42.5716 113.602 37.2798 109.229C32.1764 105.011 27.9738 99.8991 24.7892 94.0348H24.7915C21.6069 88.1705 19.6075 81.8618 18.849 75.284C18.0632 68.4644 18.6534 61.665 20.6042 55.0777C22.555 48.4905 25.7622 42.4662 30.1355 37.1744C34.3535 32.071 39.4653 27.8682 45.3296 24.6836C51.1939 21.4991 57.5026 19.4997 64.0804 18.7412Z'
            fill='#005CAD'
          />
          <path
            d='M96.3613 91.4973C96.8294 90.6333 97.9091 90.3133 98.7719 90.7814C99.6359 91.2496 99.9559 92.3293 99.4878 93.1921C96.6184 98.4828 92.3435 103.098 86.7814 106.908C79.1974 112.102 71.6064 114.158 70.1616 114.517C70.0206 114.552 69.876 114.569 69.7326 114.569C69.5892 114.569 69.447 114.552 69.3071 114.517C67.8707 114.163 60.3222 112.135 52.6896 106.908L52.6885 106.911C47.1252 103.099 42.8502 98.4839 39.9808 93.1932C39.5127 92.3293 39.8327 91.2507 40.6955 90.7826C41.5595 90.3133 42.638 90.6345 43.1062 91.4973C45.7041 96.2878 49.6045 100.487 54.6973 103.976C61.2513 108.463 67.7011 110.416 69.729 110.956C71.7687 110.409 78.2564 108.436 84.7713 103.975C89.8641 100.486 93.7634 96.2878 96.3613 91.4973Z'
            fill='#005CAD'
          />
          <path
            d='M45.8593 60.8994C46.3488 60.8994 46.7435 61.0428 47.0422 61.3307C47.3408 61.6187 47.4902 62.0194 47.4902 62.4662C47.4902 62.913 47.3408 63.2756 47.0422 63.553C46.7435 63.8303 46.3488 63.9691 45.8593 63.9691H33.0724V71.7379H42.2469C42.7364 71.7379 43.131 71.8813 43.4297 72.1693C43.7284 72.4573 43.8777 72.8259 43.8777 73.2728C43.8777 73.7196 43.7283 74.087 43.4297 74.375C43.131 74.6629 42.7364 74.8063 42.2469 74.8063H33.0724V84.2048C33.0724 84.6741 32.9124 85.0677 32.5924 85.3877C32.2724 85.7065 31.8789 85.8665 31.4095 85.8665C30.9402 85.8665 30.5468 85.7077 30.2268 85.3877C29.9068 85.0677 29.7468 84.6742 29.7468 84.2048V62.5622C29.7468 62.0716 29.9068 61.6721 30.2268 61.3628C30.5468 61.0547 30.9402 60.8994 31.4095 60.8994H45.8593Z'
            fill='#005CAD'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M58.2315 60.8982C59.8303 60.8982 61.2478 61.2348 62.484 61.9056C63.7201 62.5764 64.6837 63.4985 65.377 64.6707C66.0703 65.844 66.4164 67.2082 66.4164 68.7632C66.4164 70.2126 66.0692 71.5021 65.377 72.6316L65.3782 72.628C64.686 73.7586 63.7213 74.6429 62.4851 75.2817C62.3725 75.3397 62.2576 75.3942 62.1426 75.4475L67.0245 83.3066C67.4084 83.9252 67.4605 84.5047 67.1844 85.0487C66.9071 85.5927 66.4271 85.8641 65.7457 85.8641C65.447 85.8641 65.1755 85.8002 64.9301 85.6722C64.6848 85.5442 64.4774 85.3427 64.3068 85.0654L58.8205 76.2274C58.6274 76.2381 58.4318 76.2428 58.2327 76.2428H54.1403V84.2037C54.1403 84.673 53.9851 85.0665 53.6769 85.3865C53.3676 85.7053 52.9468 85.8653 52.4775 85.8654C52.0082 85.8654 51.6146 85.7065 51.2946 85.3865C50.9746 85.0665 50.8146 84.673 50.8146 84.2037V62.5611C50.8146 62.0704 50.9746 61.671 51.2946 61.3616C51.6146 61.0535 52.0082 60.8982 52.4775 60.8982H58.2315ZM54.1391 73.1755H58.2315C59.2117 73.1755 60.0745 72.9895 60.8211 72.6162C61.5678 72.2428 62.1534 71.7213 62.58 71.0493C63.0055 70.3773 63.2188 69.6153 63.2188 68.7632C63.2188 67.8257 63.0055 66.9948 62.58 66.2695C62.1534 65.5454 61.5666 64.9799 60.8211 64.5746C60.0745 64.1705 59.2117 63.9678 58.2315 63.9678H54.1391V73.1755Z'
            fill='#005CAD'
          />
          <path
            d='M87.0161 60.8982C87.5056 60.8982 87.9002 61.0416 88.1989 61.3296C88.4976 61.6176 88.6469 62.0182 88.6469 62.465C88.6469 62.9118 88.4976 63.2745 88.1989 63.5518C87.9002 63.8291 87.5056 63.9678 87.0161 63.9678V63.9666H74.2279V71.7355H83.4036C83.8931 71.7355 84.2878 71.879 84.5865 72.167C84.8852 72.455 85.0345 72.8235 85.0345 73.2703C85.0345 73.7171 84.8852 74.0845 84.5865 74.3725C84.2878 74.6605 83.8931 74.804 83.4036 74.804H74.2279V82.7957H87.0161C87.5056 82.7957 87.9002 82.9355 88.1989 83.2116C88.4975 83.489 88.6469 83.8291 88.6469 84.2985C88.6469 84.7678 88.4976 85.1459 88.1989 85.4339C87.9002 85.7219 87.5056 85.8653 87.0161 85.8654H72.5664C72.097 85.8654 71.7035 85.7065 71.3835 85.3865C71.0635 85.0665 70.9035 84.673 70.9035 84.2037V62.5611C70.9035 62.0704 71.0635 61.671 71.3835 61.3616C71.7035 61.0535 72.097 60.8982 72.5664 60.8982H87.0161Z'
            fill='#005CAD'
          />
          <path
            d='M108.346 60.8982C108.835 60.8982 109.23 61.0416 109.529 61.3296C109.827 61.6176 109.977 62.0182 109.977 62.465C109.977 62.9118 109.827 63.2745 109.529 63.5518C109.23 63.8291 108.835 63.9678 108.346 63.9678V63.9666H95.5578V71.7355H104.733C105.223 71.7355 105.618 71.879 105.916 72.167C106.215 72.455 106.364 72.8235 106.364 73.2703C106.364 73.7171 106.215 74.0845 105.916 74.3725C105.618 74.6605 105.223 74.804 104.733 74.804H95.5578V82.7957H108.346C108.835 82.7957 109.23 82.9355 109.529 83.2116C109.827 83.489 109.977 83.8291 109.977 84.2985C109.977 84.7678 109.827 85.1459 109.529 85.4339C109.23 85.7219 108.835 85.8654 108.346 85.8654H93.8961C93.4268 85.8653 93.0333 85.7065 92.7134 85.3865C92.3934 85.0665 92.2334 84.673 92.2334 84.2037V62.5611C92.2334 62.0704 92.3934 61.671 92.7134 61.3616C93.0334 61.0535 93.4268 60.8982 93.8961 60.8982H108.346Z'
            fill='#005CAD'
          />
          <path
            d='M68.6067 30.0762C69.2621 29.5382 70.2067 29.5382 70.8621 30.0762C75.3587 33.7657 79.924 36.4608 84.8188 38.3133C90.0763 40.3032 95.5886 41.2703 101.672 41.2703H102.021C102.491 41.2703 102.941 41.4564 103.274 41.7871C103.61 42.1213 103.798 42.5752 103.798 43.0481V54.1746C103.798 55.1559 103.002 55.9524 102.021 55.9524C101.039 55.9524 100.243 55.1559 100.243 54.1746V44.8105C94.2801 44.6683 88.8093 43.6277 83.559 41.6401C78.708 39.8043 74.1722 37.2111 69.7337 33.7314C65.2941 37.2123 60.7607 39.8055 55.9145 41.6401C50.6653 43.6277 45.1921 44.6683 39.2247 44.8105V54.1746C39.2247 55.1559 38.4283 55.9524 37.4469 55.9524C36.4656 55.9524 35.6691 55.1559 35.6691 54.1746V43.0481C35.6692 42.574 35.8576 42.1213 36.193 41.7871C36.5272 41.4564 36.9776 41.2703 37.4469 41.2703H37.7989C43.8872 41.2703 49.4007 40.3032 54.6558 38.3133C59.5459 36.4608 64.1101 33.7669 68.6067 30.0762Z'
            fill='#005CAD'
          />
        </g>
        <defs>
          <filter
            id='filter0_dddii_2039_438'
            x='-4.31839'
            y='-4.3717'
            width='148'
            height='148'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset />
            <feGaussianBlur stdDeviation='5' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0'
            />
            <feBlend
              mode='normal'
              in2='BackgroundImageFix'
              result='effect1_dropShadow_2039_438'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='-0.496757' />
            <feGaussianBlur stdDeviation='0.124189' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0'
            />
            <feBlend
              mode='normal'
              in2='effect1_dropShadow_2039_438'
              result='effect2_dropShadow_2039_438'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='0.496757' />
            <feGaussianBlur stdDeviation='0.372568' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='effect2_dropShadow_2039_438'
              result='effect3_dropShadow_2039_438'
            />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='effect3_dropShadow_2039_438'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='2.07148' />
            <feGaussianBlur stdDeviation='1.86284' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect4_innerShadow_2039_438'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='1.07796' />
            <feGaussianBlur stdDeviation='1.24189' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
            />
            <feBlend
              mode='normal'
              in2='effect4_innerShadow_2039_438'
              result='effect5_innerShadow_2039_438'
            />
          </filter>
        </defs>
      </svg>
    ),
  },
  {
    title: '100% Payment Security. Zero Financial Risk',
    text: (
      <>
        Say goodbye to clients who haggle or refuse to pay. Customers{' '}
        <strong>secure funds upfront</strong> when they book, locking the money
        in before you even pick up your tools. Once the job is done, you{' '}
        <strong>get paid directly</strong>. Guaranteed earnings,{' '}
        <strong>zero unpaid invoices.</strong>
      </>
    ),
    icon: (
      <svg
        width='140'
        height='140'
        viewBox='0 0 140 140'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_dddii_2039_441)'>
          <path
            d='M69.8472 129.303H69.8461L69.8467 129.303L69.8472 129.303Z'
            fill='#005CAD'
          />
          <path
            d='M60.2781 10.7077C67.9072 9.52729 75.6156 9.82479 83.1913 11.5907C90.767 13.3578 97.8129 16.5009 104.131 20.9347C110.683 25.5308 116.148 31.3098 120.377 38.1104C130.756 54.8037 132.259 75.5267 124.397 93.5427C124.004 94.4422 122.957 94.8535 122.056 94.4612C121.156 94.0689 120.745 93.02 121.137 92.1205C128.532 75.1771 127.119 55.6878 117.357 39.9877C113.383 33.596 108.245 28.1643 102.088 23.8443C96.143 19.6736 89.5131 16.7154 82.383 15.0526C75.2518 13.3898 67.9972 13.1101 60.821 14.2206C53.3887 15.3714 46.3783 17.9693 39.9866 21.9444C33.5949 25.9183 28.1632 31.0561 23.8432 37.2132C19.6725 43.158 16.7142 49.788 15.0514 56.918C13.3886 64.0493 13.1089 71.3039 14.2195 78.4802C15.3703 85.9125 17.9682 92.9229 21.9433 99.3146C25.9172 105.706 31.055 111.138 37.212 115.458C43.1569 119.629 49.7869 122.587 56.9169 124.25C64.0482 125.912 71.3027 126.192 78.4789 125.082C85.9112 123.931 92.9216 121.333 99.3133 117.358C100.148 116.839 101.244 117.095 101.762 117.929C102.281 118.763 102.025 119.86 101.191 120.378C94.3901 124.606 86.9317 127.371 79.0229 128.596C75.9737 129.067 72.909 129.303 69.8467 129.303C65.2507 129.303 60.6572 128.772 56.111 127.712C48.5353 125.944 41.4905 122.801 35.1711 118.368C28.6206 113.771 23.1546 107.992 18.9258 101.192C14.6971 94.3913 11.9321 86.9329 10.7078 79.0242C9.52732 71.3963 9.82471 63.6867 11.5906 56.111C13.3577 48.5353 16.501 41.4906 20.9347 35.1712C25.5309 28.6206 31.3098 23.1545 38.1104 18.9258C44.911 14.697 52.3694 11.932 60.2781 10.7077Z'
            fill='#005CAD'
          />
          <path
            d='M81.9942 21.7205C82.2727 20.7794 83.2624 20.2425 84.2035 20.521C90.7907 22.4718 96.815 25.679 102.107 30.0523C107.211 34.2704 111.414 39.3821 114.597 45.2464C117.782 51.1107 119.782 57.4194 120.54 63.9972C121.327 70.8179 120.736 77.6162 118.785 84.2034C116.834 90.7907 113.627 96.815 109.253 102.107C105.035 107.211 99.9237 111.414 94.0594 114.598C88.1951 117.781 81.8863 119.782 75.3086 120.54C73.3578 120.765 71.4081 120.878 69.4656 120.878L69.4645 120.877C64.6147 120.877 59.8052 120.177 55.1012 118.785C48.5139 116.834 42.4897 113.627 37.1978 109.253C32.0932 105.035 27.8905 99.9238 24.7071 94.0595C21.5225 88.1952 19.5231 81.8864 18.7646 75.3087C17.9776 68.4879 18.5691 61.6897 20.5199 55.1024C25.3081 38.9329 37.7394 26.1602 53.7726 20.9347C54.7065 20.6301 55.7092 21.1409 56.0138 22.0736C56.3184 23.0075 55.8075 24.0102 54.8748 24.3148C39.9545 29.1776 28.3859 41.065 23.9296 56.1121C22.1151 62.2383 21.5664 68.5601 22.2977 74.9021C23.0041 81.0259 24.8659 86.9009 27.8324 92.3634C30.7989 97.8259 34.7125 102.587 39.4639 106.513C44.3848 110.58 49.986 113.562 56.1122 115.376C62.2384 117.191 68.5602 117.739 74.9021 117.008C81.0259 116.302 86.9009 114.44 92.3634 111.473C97.8259 108.507 102.587 104.593 106.513 99.842C110.58 94.9211 113.562 89.3198 115.376 83.1936C117.191 77.0674 117.739 70.7456 117.008 64.4037C116.302 58.2798 114.44 52.4048 111.473 46.9423C108.507 41.4798 104.593 36.719 99.8419 32.7924C94.921 28.7261 89.3199 25.7441 83.1936 23.9296C82.2526 23.6511 81.7145 22.6615 81.9942 21.7205Z'
            fill='#005CAD'
          />
          <path
            d='M69.9386 67.2481C71.266 67.2481 72.4689 67.5018 73.5486 68.0078C74.6283 68.5139 75.5504 69.2736 76.3148 70.2857C76.4274 70.4208 76.5116 70.5845 76.5685 70.7753C76.6242 70.9661 76.6527 71.1522 76.6527 71.3323C76.6527 71.8277 76.489 72.2437 76.1631 72.5803C75.8372 72.9181 75.4153 73.0864 74.8974 73.0864C74.4245 73.0864 74.076 72.9406 73.8508 72.6479C73.244 72.0636 72.6751 71.5682 72.1465 71.1628C71.618 70.7575 70.9258 70.556 70.0713 70.556C69.3294 70.556 68.7048 70.7196 68.1987 71.0455C67.6927 71.3714 67.3051 71.81 67.0349 72.3611C66.7646 72.9122 66.6295 73.5475 66.6295 74.2669C66.6295 74.8073 66.6971 75.3797 66.8322 75.9877C66.9673 76.5945 67.1581 77.231 67.4058 77.8935C67.6535 78.5572 67.9344 79.2375 68.2497 79.9343H72.5009C72.9951 79.9344 73.4064 80.0979 73.7323 80.4238C74.0582 80.7497 74.2218 81.1611 74.2218 81.6553C74.2218 82.1495 74.0582 82.5726 73.7323 82.921C73.4064 83.2695 72.9951 83.4437 72.5009 83.4437H68.4855C68.463 84.5234 68.367 85.615 68.1987 86.7172C68.0304 87.8194 67.7542 88.9335 67.3726 90.057H74.6271C74.7847 89.7655 74.9246 89.4787 75.0491 89.1966C75.1723 88.9157 75.3133 88.6621 75.471 88.4369C75.6511 88.1667 75.8586 87.9474 76.0956 87.7791C76.3315 87.6108 76.6183 87.5254 76.956 87.5254C77.4503 87.5254 77.8675 87.6997 78.2041 88.0481C78.5418 88.3978 78.7101 88.8079 78.7101 89.2796C78.7101 89.5723 78.6425 89.8426 78.5074 90.0891L77.2926 92.5187C77.1125 92.879 76.8873 93.1433 76.6183 93.3115C76.3481 93.4798 76.0446 93.564 75.7068 93.564H64.8755L64.8778 93.5676C64.3148 93.5676 63.8822 93.404 63.5788 93.0781C63.2754 92.7522 63.1238 92.3421 63.1237 91.8467C63.1237 91.5552 63.1687 91.3181 63.2588 91.1379C63.8206 89.8105 64.2485 88.5057 64.5412 87.2245C64.8328 85.9421 64.9904 84.6822 65.0141 83.4449H63.5967C63.1012 83.4449 62.6911 83.2706 62.3652 82.9222C62.0393 82.5738 61.8757 82.1518 61.8757 81.6565C61.8757 81.1611 62.0381 80.751 62.3652 80.4251C62.6923 80.0992 63.1012 79.9356 63.5967 79.9356H64.6763C64.3385 79.0811 64.0576 78.3451 63.8324 77.7252C63.6072 77.1066 63.4331 76.5104 63.3099 75.9368C63.1854 75.3632 63.1237 74.7386 63.1237 74.0642C63.1237 72.8044 63.4331 71.6571 64.0517 70.6224C64.6704 69.5878 65.4965 68.7664 66.5311 68.1596C67.5658 67.5528 68.7012 67.2481 69.9386 67.2481Z'
            fill='#005CAD'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M69.6529 27.1936C79.7744 27.1936 88.009 35.4283 88.009 45.5497V57.4929L89.1954 57.6411C95.0502 58.3699 99.4662 63.3714 99.4662 69.2749V91.4662C99.4662 97.9337 94.2052 103.195 87.7376 103.195H51.5682C45.1006 103.195 39.8396 97.9337 39.8396 91.4662V69.2749C39.8396 63.3714 44.2544 58.3699 50.1104 57.6411L51.2968 57.4929V45.5497C51.2968 35.4283 59.5314 27.1936 69.6529 27.1936ZM51.567 61.1527C47.0882 61.1527 43.4438 64.7972 43.4438 69.276V91.4675C43.4438 95.9462 47.0882 99.5907 51.567 99.5907H87.7353C92.2141 99.5907 95.8586 95.9462 95.8586 91.4675V69.276C95.8586 64.7972 92.2141 61.1528 87.7353 61.1527H51.567ZM69.6517 30.7989C61.5178 30.7989 54.901 37.4158 54.9009 45.5497V57.5474H84.4026V45.5497C84.4025 37.4158 77.7856 30.7989 69.6517 30.7989Z'
            fill='#005CAD'
          />
        </g>
        <defs>
          <filter
            id='filter0_dddii_2039_441'
            x='-4.34827'
            y='-4.34949'
            width='148'
            height='148'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset />
            <feGaussianBlur stdDeviation='5' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0'
            />
            <feBlend
              mode='normal'
              in2='BackgroundImageFix'
              result='effect1_dropShadow_2039_441'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='-0.496757' />
            <feGaussianBlur stdDeviation='0.124189' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0'
            />
            <feBlend
              mode='normal'
              in2='effect1_dropShadow_2039_441'
              result='effect2_dropShadow_2039_441'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='0.496757' />
            <feGaussianBlur stdDeviation='0.372568' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='effect2_dropShadow_2039_441'
              result='effect3_dropShadow_2039_441'
            />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='effect3_dropShadow_2039_441'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='2.07148' />
            <feGaussianBlur stdDeviation='1.86284' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect4_innerShadow_2039_441'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='1.07796' />
            <feGaussianBlur stdDeviation='1.24189' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
            />
            <feBlend
              mode='normal'
              in2='effect4_innerShadow_2039_441'
              result='effect5_innerShadow_2039_441'
            />
          </filter>
        </defs>
      </svg>
    ),
  },
  {
    title: 'The Early Bird Advantage: 0% vs. Standard',
    text: (
      <>
        Our standard model is fair - you only pay a small commission after a job
        is completed. But as one of our <strong>300 Early Birds</strong>, you
        bypass even that. You get full platform access with{' '}
        <strong>0% commission for life</strong>. You keep{' '}
        <strong>100% of the invoice.</strong>
      </>
    ),
    icon: (
      <svg
        width='140'
        height='140'
        viewBox='0 0 140 140'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_dddii_2039_445)'>
          <path
            d='M50.4804 13.1465C81.5114 2.60003 115.71 19.4495 126.256 50.4816C136.762 81.3913 120.084 115.444 89.2841 126.133L88.9211 126.257C70.3288 132.577 49.7699 129.337 34.0202 117.607C33.2328 117.02 33.0698 115.906 33.6563 115.119C34.2428 114.331 35.3566 114.169 36.1441 114.755C50.9555 125.787 70.2923 128.834 87.7769 122.891C116.95 112.976 132.804 80.7974 122.89 51.6258C112.975 22.4529 80.7962 6.59839 51.6245 16.5129C22.4528 26.4275 6.59836 58.6053 16.5129 87.7782C16.8288 88.7078 16.3313 89.7176 15.4017 90.0335C14.4721 90.3494 13.4624 89.8519 13.1465 88.9223C2.60004 57.8902 19.4495 23.6929 50.4804 13.1465Z'
            fill='#005CAD'
          />
          <path
            d='M58.8134 19.6311C75.2748 16.052 92.4825 20.8107 104.767 32.3386C105.483 33.0105 105.518 34.1355 104.846 34.8515C104.175 35.5674 103.05 35.6032 102.334 34.9313C90.9024 24.2039 74.8869 19.7748 59.5687 23.1053L59.5688 23.1054C34.0133 28.6627 17.547 54.2794 23.1042 79.8349C28.6615 105.391 54.2783 121.857 79.8338 116.299C105.389 110.742 121.856 85.1255 116.298 59.57C116.09 58.6106 116.698 57.6637 117.658 57.455C118.617 57.2464 119.564 57.8552 119.773 58.8145C125.747 86.2889 108.064 113.799 80.5893 119.774C53.1149 125.748 25.6045 108.065 19.6299 80.5905C13.6554 53.1161 31.3391 25.6056 58.8134 19.6311Z'
            fill='#005CAD'
          />
          <path
            d='M88.9665 43.8903C90.3212 43.6604 91.6901 43.9733 92.8208 44.7686V44.7709C93.9538 45.5756 94.7005 46.7656 94.9304 48.1262C95.0928 49.0886 94.4444 50.0024 93.4809 50.1648C92.5161 50.3271 91.6035 49.6788 91.4412 48.7152C91.3689 48.2862 91.1331 47.9105 90.7775 47.6581C90.422 47.408 89.9846 47.3073 89.5555 47.3796C88.6679 47.5289 88.0694 48.3727 88.2187 49.2592C88.3811 50.2228 87.7327 51.1354 86.7692 51.2978C86.6696 51.3143 86.5713 51.3226 86.4729 51.3226C85.6255 51.3226 84.8764 50.7123 84.7306 49.8483C84.2566 47.0383 86.1564 44.3656 88.9665 43.8903Z'
            fill='#005CAD'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M87.8382 36.9796C91.0785 36.432 94.3366 37.1774 97.014 39.0809C99.6913 40.9831 101.467 43.8157 102.014 47.056L104.626 62.512H104.625C104.673 62.7929 104.649 63.069 104.571 63.3238C104.72 63.5881 104.802 63.8869 104.802 64.1986C104.801 64.3562 104.801 64.5138 104.798 64.6702V64.7164C104.726 73.2473 103.44 79.9934 100.868 85.3386C99.3724 88.4485 97.3956 91.1591 94.9944 93.3967C92.4415 95.7742 89.3209 97.7002 85.7179 99.1188C81.635 100.726 77.2664 101.541 72.8374 101.541C70.7716 101.541 68.6939 101.365 66.6258 101.008L36.9203 95.8856C35.619 95.6616 34.6163 94.6779 34.3686 93.3802C34.1197 92.0812 34.6874 90.7976 35.8157 90.1078L55.453 78.1221C52.8551 75.3641 50.7419 72.1676 49.1585 68.5884C47.3831 64.5766 46.2145 59.9496 45.6835 54.8356C45.5389 53.4359 46.1102 52.0788 47.2112 51.2053C48.311 50.3342 49.7582 50.0877 51.0845 50.5464L57.8317 52.886C59.3416 48.7674 61.6965 44.6204 64.8503 40.5327C65.5034 39.6877 66.5275 39.2314 67.5917 39.3156C68.6513 39.3986 69.5887 40.0054 70.0995 40.9393L77.2581 54.0071C77.3138 53.1194 77.3682 52.2352 77.4228 51.357C77.4856 50.3449 77.5485 49.3327 77.6125 48.3206C77.7843 45.5982 78.8818 42.9719 80.7034 40.9251C82.5535 38.8463 85.0874 37.4442 87.8382 36.9796ZM94.9659 41.9656C93.059 40.6097 90.7383 40.0788 88.4296 40.4687C84.3976 41.149 81.4015 44.4699 81.1455 48.5434C81.0815 49.5543 81.0198 50.5653 80.957 51.5751C80.7792 54.442 80.5979 57.3718 80.381 60.3052C80.381 60.317 80.3799 60.3301 80.3787 60.342C80.259 61.9479 80.1298 63.5537 79.984 65.1513L79.8725 66.3781C83.1235 66.8522 85.9431 68.8788 87.4317 71.8157C87.4329 71.8169 87.4389 71.8193 87.4389 71.8193C88.1393 71.536 88.867 71.3286 89.6018 71.2041C92.1215 70.7787 94.6862 71.3144 96.8243 72.7141C97.6409 73.2486 97.8708 74.3449 97.3352 75.1627C96.9962 75.6806 96.4308 75.9627 95.8537 75.9627C95.5218 75.9627 95.1852 75.869 94.8865 75.6735C93.4963 74.7644 91.8287 74.4148 90.1908 74.6921C89.7132 74.7727 89.2379 74.9079 88.7792 75.0928C88.5387 75.1935 88.2874 75.267 88.0314 75.3097C86.5085 75.568 84.9618 74.7882 84.2732 73.4134C83.9769 72.8279 83.5965 72.2981 83.1532 71.8358C83.0525 71.7564 82.96 71.6652 82.8771 71.5644C81.8933 70.653 80.6417 70.0474 79.274 69.8637C77.8921 69.68 76.7449 68.6951 76.3526 67.3534C76.2898 67.1401 76.2685 66.9173 76.2886 66.6968L76.4581 64.829C76.5873 63.4115 76.7033 61.9846 76.8112 60.5553L67.2871 43.1709C64.5517 46.7964 62.5025 50.4457 61.1751 54.0463L73.6408 58.3686C74.5629 58.6886 75.0525 59.696 74.7325 60.6193C74.4125 61.5425 73.405 62.0308 72.4818 61.7108L49.9265 53.8898C49.6812 53.8045 49.4975 53.9088 49.4098 53.9775C49.3209 54.0474 49.1763 54.2063 49.2036 54.4706C50.2228 64.2862 53.5899 71.7066 59.5004 77.1549C61.8862 79.3558 64.7413 81.258 67.9863 82.8106C68.8669 83.2313 69.2403 84.2874 68.8184 85.1692C68.515 85.8044 67.8821 86.1754 67.222 86.1754C66.966 86.1754 66.7063 86.1186 66.4598 86.0012C63.338 84.5079 60.5339 82.7099 58.1078 80.6453L38.5593 92.5766L67.2279 97.52C73.0945 98.5321 79.0394 97.9466 84.4225 95.8263C95.9259 91.2966 101.119 81.6883 101.263 64.6785V64.6228L101.264 64.624C101.266 64.5245 101.266 64.4237 101.266 64.323C101.25 64.1002 101.278 63.8797 101.342 63.6723C101.245 63.5004 101.174 63.3096 101.14 63.1034L98.5274 47.6474C98.1375 45.3387 96.8729 43.3214 94.9659 41.9656Z'
            fill='#005CAD'
          />
          <path
            d='M102.64 45.4655C102.947 44.5387 103.947 44.035 104.875 44.342C107.224 45.1195 109.258 46.1114 111.095 47.376C111.889 47.9212 112.305 48.8551 112.177 49.814C112.049 50.7751 111.4 51.5704 110.484 51.8903C109.158 52.3538 107.855 53.0838 106.612 54.0581C106.287 54.3117 105.903 54.4349 105.521 54.4349C104.996 54.4349 104.476 54.2026 104.127 53.757C103.524 52.9878 103.659 51.8761 104.428 51.274C105.42 50.4966 106.452 49.8412 107.509 49.315C106.369 48.6857 105.131 48.1535 103.764 47.7008C102.837 47.3938 102.333 46.3935 102.64 45.4655Z'
            fill='#005CAD'
          />
        </g>
        <defs>
          <filter
            id='filter0_dddii_2039_445'
            x='-4.29868'
            y='-4.2998'
            width='148'
            height='148'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset />
            <feGaussianBlur stdDeviation='5' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0'
            />
            <feBlend
              mode='normal'
              in2='BackgroundImageFix'
              result='effect1_dropShadow_2039_445'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='-0.496757' />
            <feGaussianBlur stdDeviation='0.124189' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0'
            />
            <feBlend
              mode='normal'
              in2='effect1_dropShadow_2039_445'
              result='effect2_dropShadow_2039_445'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='0.496757' />
            <feGaussianBlur stdDeviation='0.372568' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='effect2_dropShadow_2039_445'
              result='effect3_dropShadow_2039_445'
            />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='effect3_dropShadow_2039_445'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='2.07148' />
            <feGaussianBlur stdDeviation='1.86284' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect4_innerShadow_2039_445'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='1.07796' />
            <feGaussianBlur stdDeviation='1.24189' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
            />
            <feBlend
              mode='normal'
              in2='effect4_innerShadow_2039_445'
              result='effect5_innerShadow_2039_445'
            />
          </filter>
        </defs>
      </svg>
    ),
  },
];

export const BenefitsBlock = ({ isDark }: { isDark: boolean }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 3, tablet: 4 },
        maxWidth: '760px',
        mx: 'auto',
      }}
    >
      {benefits.map((item, index) => {
        const isEven = index % 2 === 0;

        return (
          <Box
            key={index}
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                tablet: isEven ? '128px 1fr' : '1fr 128px',
              },
              alignItems: 'center',
              gap: { xs: 2, tablet: 4 },
              p: 4,
              borderRadius: '32px',
              boxShadow: `
                -2.82px -2.82px 8.49px 0px rgba(184, 255, 255, 0.31),
                14.15px 14.15px 22.64px -5.37px rgba(0, 0, 0, 0.1),
                -17.54px -17.54px 28.66px 0px rgba(199, 255, 255, 0.29),
                5px 5px 24px -11.7px rgba(0, 181, 181, 0.49)
                `,
            }}
          >
            {/* icon */}
            <Box
              sx={{
                width: '100%',
                display: { xs: 'none', tablet: 'flex' },
                alignSelf: 'start',
                order: isEven ? 0 : 2,

                '& path': {
                  fill: isDark ? GlassColors.accent : GlassColors.secondary,
                },
              }}
            >
              {item.icon}
            </Box>

            <Box>
              {/* title with icon on mobile  */}
              <Box
                display='flex'
                sx={{
                  mb: { xs: '16px', tablet: '10px' },
                  alignItems: 'center',
                  gap: '16px',
                  flexDirection: { xs: 'column', mobile: 'row' },
                }}
              >
                <Box
                  sx={{
                    width: '96px',
                    height: '96px',
                    display: { xs: 'flex', tablet: 'none' },
                    alignItems: 'center',
                    justifyContent: 'center',
                    justifySelf: 'center',
                    order: { xs: 0, mobile: isEven ? 0 : 2 },

                    '& path': {
                      fill: isDark ? GlassColors.accent : GlassColors.secondary,
                    },
                  }}
                >
                  {item.icon}
                </Box>
                <Typography
                  variant='h5'
                  sx={{
                    fontFamily: 'Montserrat, sans-serif',
                    fontWeight: 800,
                    fontSize: '20px',
                    lineHeight: 1.6,
                    letterSpacing: '.15px',
                    color: isDark ? GlassColors.accent : GlassColors.secondary,
                  }}
                >
                  {item.title}
                </Typography>
              </Box>
              {/* text  */}
              <Typography
                variant='body1'
                sx={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: { xs: '14px', tablet: '16px' },
                  letterSpacing: '.15px',
                  color: isDark
                    ? GlassColors.dark.textPrimary
                    : GlassColors.light.textPrimary,
                }}
              >
                {item.text}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
